import { render, staticRenderFns } from "./CreateMerge.vue?vue&type=template&id=0901f1e7&"
import script from "./CreateMerge.vue?vue&type=script&lang=js&"
export * from "./CreateMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports